<template>
  <div id="components-form-demo-advanced-search">
    <a-form
      class="ant-advanced-search-form"
      :form="form"
      @submit="handleSearch"
    >
      <a-row :gutter="24">
        <a-col
          v-for="(formItem, i) in formArr"
          :key="formItem.label"
          :md="6"
          :sm="8"
          :style="{ display: i < count ? 'block' : 'none' }"
        >
          <a-form-item :label="formItem.label">
            <a-input
              v-if="formItem.type == 'input'"
              v-decorator="[formItem.fieldStr]"
              :placeholder="formItem.placehold"
            />
            <!-- <a-select
              show-search
              v-if="formItem.type == 'selectSearch'"
              v-decorator="[formItem.fieldStr]"
              :placeholder="formItem.placehold"
              :default-active-first-option="false"
              :show-arrow="false"
              :filter-option="false"
              :not-found-content="null"
              @search="(value) => handleSearchSelect(value)"
              @change="(value) => handleChange(value)"
            >
              <a-select-option v-for="item in options" :key="item.val">{{
                item.text
              }}</a-select-option>
            </a-select> -->
            <select-search
              v-if="formItem.type == 'selectSearch'"
              v-decorator="[formItem.fieldStr]"
              :fieldCode="formItem.fieldCode"
              :requestUrl="formItem.url"
              @handleVal="(val) => handleVal(val, formItem.fieldStr)"
            ></select-search>
            <select-dict
              v-if="formItem.type == 'selectDict'"
              :dictCode="formItem.dictCode"
              v-decorator="[formItem.fieldStr]"
            />
            <a-select
              v-if="formItem.type == 'select'"
              :placeholder="formItem.placehold"
              v-decorator="[formItem.fieldStr]"
            >
              <a-select-option
                v-for="item in formItem.options"
                :key="item.val"
                >{{ item.text }}</a-select-option
              >
            </a-select>
            <a-date-picker
              style="width: 100%"
              :format="'YYYY-MM-DD'"
              v-decorator="[formItem.fieldStr]"
              v-if="formItem.type == 'date'"
            />
            <a-range-picker
              :format="'YYYY-MM-DD'"
              v-decorator="[formItem.fieldStr]"
              v-if="formItem.type == 'dateRange'"
            />
          </a-form-item>
        </a-col>

        <a-col :md="6" :sm="8" :style="{ textAlign: 'left' }">
          <a-button type="primary" html-type="submit">查询 </a-button>
          <a-button :style="{ marginLeft: '8px' }" @click="handleReset">
            重置
          </a-button>
          <!-- 大多数情况不会在第一行内显示展开收起的按钮-->
          <a
            :style="{ marginLeft: '8px', fontSize: '14px' }"
            @click="toggle"
            v-if="showMore"
          >
            {{ !expand ? '展开' : '收起' }}
            <a-icon :type="expand ? 'up' : 'down'" />
          </a>
        </a-col>
      </a-row>
      <!-- <a-row v-if="formArr.length >= 4">
        <a-col :span="24" :style="{ textAlign: 'left' }">
          <a-button type="primary" html-type="submit">查询 </a-button>
          <a-button :style="{ marginLeft: '8px' }" @click="handleReset">
            重置
          </a-button>
          <a :style="{ marginLeft: '8px', fontSize: '14px' }" @click="toggle">
            {{ !expand ? '展开' : '收起' }}
            <a-icon :type="expand ? 'up' : 'down'" />
          </a>
        </a-col>
      </a-row> -->
    </a-form>
  </div>
</template>
<script>
/**
 * author 周娇
 * desc 高级搜索，根据配置文件加载不同的form表单，默认一行显示3列
 * params:
 *  requestUrl : 查询的接口地址
 *  showMore : 显示展开收起按钮
 *  paramType : 接口入参时formData格式还是json格式
 *  formStr : 配置项的名称
 *  selectData: 下拉框数据 Object类型，根据配置项里面的optionDataKey字段，去下拉框数据
 *  引用  <advanced-search :formStr="'productForm'"></advanced-search>
 */
import formData from './config';
import { getAction } from '@/api/manage';
import moment from 'moment';
import SelectDict from '@/components/common/SelectDict.vue'; //下拉组件
import SelectSearch from '@/components/common/SelectSearch.vue'; //下拉-搜索组件
export default {
  props: {
    showMore: {
      type: Boolean,
      default: true,
    },
    paramType: {
      type: String,
      default: 'json',
    },
    formStr: {
      type: String,
      default: 'defaultForm',
    },
    handleSeach: {
      type: Function,
      default: () => {},
    },
  },
  components: {
    SelectDict,
    SelectSearch,
  },
  data() {
    return {
      expand: false,
      form: this.$form.createForm(this),
      formArr: [],
      count: 3,
      value: undefined,
      options: [
        {
          val: 0,
          text: '未审核',
        },
        {
          val: 1,
          text: '已审核',
        },
        {
          val: 2,
          text: '已驳回',
        },
      ],
    };
  },
  created() {
    this.formArr = formData[this.formStr];

    console.log('selectData', this.selectData);
    if (this.selectData) {
      this.handleSelectOption();
    }
  },
  methods: {
    //处理下拉数据
    handleSelectOption() {
      this.formArr.forEach((item) => {
        if (item.type == 'select' || item.type == 'selectSearch') {
          item.optionData = this.selectData[item.optionDataKey];
        }
      });
    },
    //搜索
    handleSearch(e) {
      e.preventDefault();
      this.form.validateFields((error, values) => {
        //处理form表单数据
        let obj = this.handleDateFormat({ ...values });
        if (!this.requestUrl) {
          return;
        }
        let params = {
          ...obj,
          pageSize: 10,
          pageNo: 1,
        };
        this.$emit('handleSeach', params);
      });
    },
    //重置
    handleReset() {
      this.form.resetFields();
    },
    // 展开收起
    toggle() {
      this.count = this.expand ? 3 : this.formArr.length;
      this.expand = !this.expand;
    },
    handleSearchSelect(val) {
      let arr = [];
      this.options.forEach((item) => {
        if (item.text.indexOf(val) > -1) {
          arr.push(item);
        }
      });
      this.options = arr;
    },
    handleChange(val) {
      // this.selectedOption = val;
      this.options = [
        {
          val: 0,
          text: '未审核',
        },
        {
          val: 1,
          text: '已审核',
        },
        {
          val: 2,
          text: '已驳回',
        },
      ];
    },
    handleVal(val, str) {
      this.form.setFieldsValue({ [str]: val });
    },
    handleDateFormat(params) {
      //处理日期格式
      Object.keys(params).forEach((key) => {
        if (!params[key]) {
          params[key] = '';
        }
        if (params[key] && params[key]._isAMomentObject) {
          params[key] = moment(params[key]).format('YYYY-MM-DD');
          console.log(params);
        }
        if (params[key] && params[key] instanceof Array) {
          params[key][0] = params[key][0]._isAMomentObject
            ? moment(params[key][0]).format('YYYY-MM-DD')
            : params[key][0];
          params[key][1] = params[key][1]._isAMomentObject
            ? moment(params[key][1]).format('YYYY-MM-DD')
            : params[key][1];
        }
      });

      return params;
    },
  },
};
</script>
<style>
.ant-advanced-search-form {
  background: #fff;
  border-radius: 6px;
}

.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}
</style>
